import React from 'react';

import {HOUSEKEEPING_STATUS_TO_COLOR_MAPPER} from 'ducks/allocations';
import './styles.css';

const HousekeepingStatusOption = ({option}) => (
  <div className="HousekeepingStatusOption">
    <div
      className="ellipse"
      style={{
        backgroundColor: HOUSEKEEPING_STATUS_TO_COLOR_MAPPER[option.label]
      }}
    />
    <div className="HousekeepingStatusOption__label colab-bold">
      {option.label}
    </div>
  </div>
);

export default HousekeepingStatusOption;
